import { getCsrfToken } from '../helpers/forms';

export default class Uploader {

    constructor(inputElementOrName, imageElement = null, uploadUrl = null) {
        this.input = inputElement && inputElement instanceof HTMLInputElement ? inputElementOrName : null;
        this.name = typeof inputElementOrName == 'string' ? inputElementOrName : null;
        this.image = imageElement;
        this.uploadUrl = uploadUrl ? uploadUrl : document.location.pathname;
        this.uploadHeaders = {};
        this.beforeUploading = null;
        this.onUploaded = null;
        this.afterUploading = null;
        this.onError = null;

        let me = this;

        if(this.input) {
            this.input.addEventListener('change', function(e){
                me.upload(e.target.files[0]);   
            });
        }
    }

    upload(file, datKey = undefined) {
        let me = this;
        let formData = new FormData();
        formData.append(dataKey ? dataKey : this.name, file);

        if(this.beforeUploading) {
            this.beforeUploading.call(this, formData);
        }

        let headers = {};
        let csrfToken = getCsrfToken();
        if(csrfToken) {
            headers['X-CSRF-TOKEN'] = csrfToken;
        }

        fetch(this.uploadUrl, {
            method: 'POST',
            body: formData,
            headers: Object.assign(headers, this.uploadHeaders)
        }).then(function(response) {
            return response.json();
        }).then(function(json) {
            if(json.success) {
                me.uploaded(json.data);
            } else {
                me.error(json.message);
            }

            if(me.afterUploading) {
                me.afterUploading.call(me, json);
            }
        });
    }

    uploaded(fileData) {
        if(this.onUploaded) {
            this.onUploaded.call(this, fileData);
        }
    }

    error(errorMessage) {
        if(this.onError) {
            this.onError(errorMessage);
        }
    }
}